import etehadieImgPng from '../../../assets/images/etehadiye.png';
import etehadieImgWebp from '../../../assets/images/etehadiye.webp';
import samandehiImgPng from '../../../assets/images/samandehi.png';
import samandehiImgWebp from '../../../assets/images/samandehi.webp';
import enamadImgPng from '../../../assets/images/enamad.png';
import enamadImgWebp from '../../../assets/images/enamad.webp';

const footerTabs = [
  {
    title: 'تپسی',
    items: [
      {
        title: 'وبلاگ تپسی',
        link: 'https://blog.tapsi.ir/',
      },
      {
        title: 'فرصت‌های شغلی',
        link: '/',
      },
      {
        title: 'تماس با ما',
        link: 'https://tapsi.ir/contact',
      },
      {
        title: 'لوگو و هویت سازمانی',
        link: 'https://tapsi.ir/brand',
      },
    ],
  },
  {
    title: 'مسافران',
    items: [
      {
        title: 'دانلود اپ مسافر',
        link: 'https://tapsi.ir/passengers/dl',
      },
      {
        title: 'نسخه وب تپسی',
        link: 'https://app.tapsi.cab/',
      },
      {
        title: 'پرسش های متداول مسافران',
        link: 'https://tapsi.ir/passengers/faq',
      },
      {
        title: 'شرایط و قوانین مسافران',
        link: 'https://tapsi.ir/terms/passengers',
      },
      {
        title: 'باشگاه مشتریان',
        link: 'https://tapsi.ir/spaceship/',
      },
    ],
  },
  {
    title: 'رانندگان',
    items: [
      {
        title: 'دانلود اپ سفیر',
        link: 'https://tapsi.ir/drivers/dl',
      },
      {
        title: 'ثبت نام راننده تاکسی اینترنتی',
        link: 'https://join.tapsi.cab/',
      },
      {
        title: 'پرسش های متداول سفیران',
        link: 'https://tapsi.ir/drivers/faq',
      },
      {
        title: 'شرایط و قوانین سفیران',
        link: 'https://tapsi.ir/terms/drivers',
      },
      {
        title: 'باشگاه سفیران',
        link: 'https://tapsi.ir/pro',
      },
    ],
  },
  {
    title: 'کسب و کارها',
    items: [
      {
        title: 'پنل سازمانی تپسی',
        link: 'https://co.tapsi.ir/login',
      },
      {
        title: 'خرید کد شارژ و تخفیف',
        link: 'https://vouchers.tapsi.ir/login',
      },
      {
        title: 'دریافت API',
        link: 'https://tapsi.ir/corporate',
      },
    ],
  },
];

export const trustLogo = [
  {
    name: 'etehdieye-logo',
    imagePng: etehadieImgPng,
    imageWebp: etehadieImgWebp,
    id: '',
  },
  {
    name: 'samandehi-logo',
    imagePng: samandehiImgPng,
    imageWebp: samandehiImgWebp,
    id: 'jxlzfukzapfuoeukoeuksizp',
  },
  {
    name: 'enamad-logo',
    imagePng: enamadImgPng,
    imageWebp: enamadImgWebp,
    id: '7jelItGhNaXbhvYrHRN5',
  },
];

export default footerTabs;
